import { TableColumn } from "../TableProps";

/**
 * 获取准确的行宽，只有全部列都声明了具体数值的列宽时才可取得
 */
export function getRowExactWidth(columns: TableColumn[]) {
  let width = 0;
  for (const column of columns) {
    if (typeof column.width !== "number") {
      return null;
    }
    width += column.width;
  }
  return width;
}
